class NewsletterForm extends HTMLElement {
  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
    this.subscribe = this.subscribe.bind(this);

    this.form = this.querySelector('form');
    this.input = this.querySelector('input');
    this.error = this.querySelector('.form-error');
    this.success = this.querySelector('.note--success');
    this.form.addEventListener('submit', this.onSubmit);
  }

  get value() {
    return this.input.value;
  }

  get hasValue() {
    return this.value && this.value.length > 0;
  }

  get klavyioListId() {
    return (
      this.getAttribute('klavyio-list-id') ||
      window.theme.settings.klaviyoListId
    );
  }

  onSubmit(event) {
    event.preventDefault();
    if (!this.hasValue) return;

    this.error.classList.add('hidden');
    this.success.classList.add('hidden');

    this.subscribe(this.klavyioListId, this.value).then((data) => {
      if (data.success && data.errors.length === 0) {
        this.success.classList.remove('hidden');
      } else {
        this.error.classList.remove('hidden');
      }
    });
  }

  subscribe(listId, email) {
    const config = Object.assign({}, { g: listId, email });
    const body = Object.keys(config).reduce((str, key) => {
      str.append(key, config[key]);
      return str;
    }, new URLSearchParams());

    return fetch(
      'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Headers': '*',
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
        body,
      }
    ).then((res) => res.json());
  }
}

defineCustomElement('newsletter-form', NewsletterForm);
